import React, { Component } from "react";
import MyNavbar from "../../components/Navbar/MyNavbar";
import PublishNotice from "../../components/client/PublishNotice/PublishNotice";

export default class PublishNoticePage extends Component {
  render() {
    return (
      <div>
        <MyNavbar />
        <PublishNotice />
      </div>
    );
  }
}
